/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestemailsfeature2Inputs */

const en_requestemailsfeature2 = /** @type {(inputs: Requestemailsfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request emails`)
};

const de_requestemailsfeature2 = /** @type {(inputs: Requestemailsfeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mails zu Anfragen`)
};

/**
* | output |
* | --- |
* | "Request emails" |
*
* @param {Requestemailsfeature2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestemailsfeature2 = /** @type {((inputs?: Requestemailsfeature2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestemailsfeature2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestemailsfeature2(inputs)
	return de_requestemailsfeature2(inputs)
});
export { requestemailsfeature2 as "requestEmailsFeature" }